export class Card {
    key: string;
    nameFa: string;
    bins: Array<any>;
    capabilities: Array<any>;
    isPartner: false;
    gradient1: string;
    gradient2: string;
    textColor: string;
    numberColor: string;
    degree: string;
    constructor(card?) {
        this.key = card?.key || '';
        this.nameFa = card?.nameFa || '';
        this.bins = card?.bins || [];
        this.capabilities = card?.capabilities || [];
        this.isPartner = card?.isPartner || false;
        this.gradient1 = card?.gradient1 || '#00a7e5';
        this.gradient2 = card?.gradient2 || '#008cbf';
        this.textColor = card?.textColor || '#fffff';
        this.numberColor = card?.numberColor || '';
        this.degree = card?.degree || '';
    }
}
